
// init
const   utils               = require('../lib/utils');
var     config              = require('../lib/config');
var     clientBaseConfig    = require('./appConfig');

// has the config been initialized yet?
var configInitialized = false;

config.setConfig = function(clientAppConfig, requireContexts){
    // prepare config if necessary
    if(configInitialized) return;
    configInitialized = true;

    // prepare require contexts
    if(typeof(requireContexts) != 'undefined'){
        this.data.requireContexts.templates    = requireContexts.templates;
        this.data.requireContexts.components   = requireContexts.components;
        this.data.requireContexts.styles       = requireContexts.styles;
    }

    // set config merge
    this.data.config = utils.simpleMerge(
        clientBaseConfig,
        clientAppConfig || {}
    );

	// init utils.moment
	utils.initMoment((this.data.config || {}).defaultTimeZone || 'Europe/Vienna', (this.data.config || {}).defaultMomentLocale || 'de')

    return this.getConfig()
};

module.exports = config;
